
import { Component, Vue, Prop } from 'vue-property-decorator';

// interface TableColumn {
//   key: string;
//   title: string;
// }

// interface TableRow {
//   id: string;
//   [key: string]: string | number;
// }

@Component
export default class DraggableFixedTable extends Vue {
  // 列定义
  // private columns: TableColumn[] = Array.from({ length: 14 }, (_, i) => ({
  //   key: `col${i + 1}`,
  //   title: `列${i + 1}`,
  // }));

  @Prop({ type: Array, default: () => [] })
  private Data!: any[];

  @Prop({ type: Array, default: () => [] })
  private columns!: any[];

  // // 主表列（不含固定列）
  get mainColumns(): any[] {
    return this.columns;
  }

  // // 固定列（最后一列）
  get fixedColumn(): any {
    return this.columns[this.columns.length - 1];
  }

  // 表格数据源
  private rows: any[] = [];

  // 当前拖拽索引
  private dragIndex: number | null = null;

  mounted() {
    this.initData();
  }

  // 初始化数据
  private initData(): void {
    // this.rows = Array.from({ length: 6 }, (_, i) => {
    //   const row: Record<string, any> = { id: `row-${i}` };
    //   this.columns.forEach(col => {
    //     row[col.key] = `R${i + 1}${col.key.toUpperCase()}`;
    //   });
    //   return row;
    // });
  }

  // 拖拽开始事件
  private onDragStart(index: number): void {
    this.dragIndex = index;
  }

  // 拖拽释放事件
  private onDrop(dropIndex: number): void {
    if (this.dragIndex === null || this.dragIndex === dropIndex) return;
    const rows = this.Data;
    const movedItem = rows.splice(this.dragIndex, 1)[0];
    rows.splice(dropIndex, 0, movedItem);
    this.$emit('updaßteData', rows);
  }
}
